module.exports = __webpack_public_path__ + "img/client-7.jpg?c7ffb79da392a55b630cba5a5bc8b5a0";